<template>
  <div v-if="!isApp && noData">
    <v-card class="d-flex align-center justify-center flex-column" flat height="50vh">
      <template v-if="!loading">
        <v-card-subtitle class="text-center">
          برای استفاده از "تماس یار" می بایست ابتدا اپلیکیشن اندروید را نصب کنید.
          <br>
          و از طریق اپلیکیشن وارد این صفحه شوید.
        </v-card-subtitle>
        <v-card-actions class="justify-center">
          <v-btn class="rounded-lg px-4" color="success" depressed download href="/assets/application/app-release.apk">
            <v-icon left>mdi-download</v-icon>
            دانلود مستقیم
          </v-btn>
        </v-card-actions>
      </template>

      <template v-else>
        <v-progress-circular indeterminate size="50" width="5"/>
        <v-card-title>درحال بررسی...</v-card-title>
      </template>
    </v-card>
  </div>

  <div v-else-if="isApp && !hasPermission" class="w-100 py-4">
    <v-stepper v-model="e6" flat vertical>
      <v-stepper-step :complete="e6 > 1" step="1">اتصال و ایجاد دسترسی</v-stepper-step>
      <v-stepper-content step="1">
        <v-btn :loading="callLoading" class="rounded-lg btn-attribute" depressed @click="getCallLogList">
          اتصال و ایجاد دسترسی
        </v-btn>

        <v-card-subtitle>
          برای ایجاد دسترسی اپلیکیشن به تماس‌های موبایل خود، نیاز است ابتدا دسترسی‌های لازم را فعال کنید.
          <br>
          شما می‌توانید در هر زمان دسترسی‌های فوق را غیرفعال نمایید.
        </v-card-subtitle>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 2" step="2">دسترسی بهینه‌سازی باتری</v-stepper-step>
      <v-stepper-content step="2">
        <v-btn :loading="callLoading" class="rounded-lg btn-attribute" depressed @click="getBatteryPermission">
          اتصال و ایجاد دسترسی
        </v-btn>

        <v-card-subtitle>
          برای ایجاد دسترسی بهینه‌سازی باتری، نیاز است ابتدا دسترسی لازم را فعال کنید.
          <br>
          شما می‌توانید در هر زمان دسترسی فوق را غیرفعال نمایید.
        </v-card-subtitle>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 3" step="3">انتخاب پترن یا کمپین</v-stepper-step>
      <v-stepper-content step="3">
        <save-steps v-model="dialog" :selected.sync="selectedRow"/>

        <v-card class="mb-12" flat>
          <v-btn class="btn-edit" depressed @click="dialog = true">
            <v-icon left>mdi-clipboard-list-outline</v-icon>
            انتخاب پترن/کمپین
          </v-btn>

          <template v-if="selectedRow && selectedRow.length">
            <p class="px-4 pt-4 font-size-h4">
              {{ Object.hasOwn(selectedRow[0], 'messages') ? 'کمپین' : 'پترن' }} انتخاب شده:
              {{ selectedRow[0].id }}
            </p>

            <div v-if="!Object.hasOwn(selectedRow[0], 'messages')"
                 class="pa-4 grey lighten-2 rounded-lg fit-content font-size-h6" style="width: fit-content">
              <pre v-html="selectedRow[0].content"/>
            </div>

            <div v-else-if="selectedRow[0].messages && selectedRow[0].messages.text" class="d-flex">
              <div v-for="(item, i) in selectedRow[0].messages.text" :key="i"
                   class="ma-2 pa-4 grey lighten-2 rounded-lg fit-content font-size-h6" style="width: fit-content">
                <v-avatar class="mt-n12 ms-n6 white--text pa-2" color="success" size="24">{{ i + 1 }}</v-avatar>
                <pre class="mt-n6 ma-0" v-html="item"/>
              </div>
            </div>
          </template>
        </v-card>
        <v-btn :disabled="!selectedRow || !selectedRow.length" :loading="patternLoading" color="btn-accept"
               depressed width="120" @click="setDefault">
          <v-icon left>mdi-content-save-outline</v-icon>
          ثبت
        </v-btn>
      </v-stepper-content>
    </v-stepper>
  </div>

  <v-card v-else flat>
    <v-card-title class="px-0 px-md-4">
      <v-card v-if="!$vuetify.breakpoint.mobile" class="rounded-lg d-flex align-center blue lighten-2"
              flat @click="() => {userPackage && (showTransactions = true)}">
        <template v-if="!!userPackage">
          <div class="d-flex justify-center align-center px-4 white--text mx-2 text-break">
            <b class="me-2">تعداد موجودی:</b>
            {{ userPackage.stock }}
            پیامک
          </div>

          <v-btn :loading="loading" class="me-2" dark icon small @click.stop="getUserPackage">
            <v-icon small>mdi-reload</v-icon>
          </v-btn>
        </template>

        <span v-else-if="!loading" class="px-4 white--text" @click="dialog = true">خرید بسته پیامک</span>
        <v-spacer/>
        <v-btn :loading="packageLoading || loading" class="rounded-lg" color="success" depressed fab small
               @click.stop="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card>

      <v-card v-else class="col-12 rounded-lg d-flex flex-column" dark flat
              style="background: linear-gradient(-45deg, #182848, #4b6cb7);">
        <div v-if="!!userPackage" @click="() => {userPackage && (showTransactions = true)}">
          <v-card-subtitle class="pa-2 d-flex align-center">
            تعداد موجودی پیامک:
            <v-spacer/>
            <v-btn :loading="packageLoading || loading" class="rounded-lg" color="success" depressed fab x-small
                   @click.stop="dialog = true">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-card-title v-if="!loading" class="px-2 py-0">
            <b class="font-size-h3">{{ price(userPackage.stock) }}</b>
            <span class="font-size-h6 mx-1 grey--text">عدد</span>
            <v-btn :loading="loading" class="mx-2" dark icon small @click.stop="getUserPackage">
              <v-icon small>mdi-reload</v-icon>
            </v-btn>
          </v-card-title>

          <v-skeleton-loader v-else class="my-1" type="text"/>
        </div>

        <v-spacer/>
        <v-card-actions v-if="!userPackage && !loading">
          <span>خرید بسته پیامک</span>
          <v-spacer/>
          <v-btn :loading="packageLoading || loading" class="rounded-lg" color="success" depressed fab x-small
                 @click.stop="dialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-spacer/>
      <v-btn :disabled="!selection || !selection.length" :loading="loading" class="rounded-lg btn-accept" depressed
             @click="submitCallLogs">
        <v-icon left>mdi-content-save-plus-outline</v-icon>
        ذخیره انتخاب شده‌ها
      </v-btn>
      <v-btn :disabled="!selection || !selection.length" :loading="loading" class="rounded-lg btn-delete" depressed
             title="حذف انتخاب شده‌ها" @click="deleteSelection">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="px-0 px-md-4">
      <vue-table v-model="selection" :data="data" :debounce-delay="1000" :headers="headers" :loading.sync="loading"
                 :props.sync="tableProps" show-select @change="onPagination">
        <template v-slot:filters="{perPage, props}">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="6">
              <v-select v-model="props.length" :items="perPage" :menu-props="{ offsetY: true }" class="rounded-lg"
                        dense hide-details label="تعداد" outlined/>
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="6">
              <v-text-field v-model="props.search" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable
                            dense hide-details label="جستجو" outlined/>
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="6">
              <v-select v-model="props.type" :color="typeText(props.type).color || 'primary'" :items="typeItems"
                        :menu-props="{ offsetY: true }" class="rounded-lg" clear-icon="mdi-close-circle-outline"
                        clearable dense hide-details label="نوع" outlined>
                <template v-slot:selection="{item}">
                  <v-icon :color="typeText(item.value).color" right small>{{ item.icon }}</v-icon>
                  {{ item.text }}
                </template>

                <template v-slot:item="{item}">
                  <v-icon :color="typeText(item.value).color" right small v-text="item.icon"/>
                  {{ item.text }}
                </template>
              </v-select>
            </v-col>
          </v-row>
        </template>

        <template v-slot:top>
          <v-card-subtitle>
            با انتخاب شماره‌های مورد نظر، می‌توانید آنرا در لیست مخاطبین خود ذخیره کنید.
          </v-card-subtitle>
        </template>

        <template v-slot:index="{item}">
          {{ (item.index + 1) + ((data.current_page - 1) * data.per_page) }}
        </template>

        <template v-slot:number="{item}">
          <span class="d-block text-right" style="direction: ltr">{{ item.number }}</span>
        </template>

        <template v-slot:name="{item}">
          {{ item.name || '-' }}
        </template>

        <template v-slot:duration="{item}">
          <template v-for="(t, i) in durationSlot(item.duration)">
            <span v-if="t.time">
              {{ t.time }}
              {{ i === 'min' ? 'دقیقه' : 'ثانیه' }}
            </span>
            <span v-else>-</span>
          </template>
        </template>

        <template v-slot:date="{item}">
          <span>{{ datetime(item.date, 'datetime') }}</span>
        </template>

        <template v-slot:type="{item}">
          <v-icon :color="typeText(item.type).color" right small>mdi-{{ typeText(item.type).icon }}</v-icon>
          <span>{{ typeText(item.type).text }}</span>
        </template>

        <template v-slot:added="{item}">
          <v-chip :color="item.added ? 'success' : 'red'" dark small>
            <v-icon left small>mdi-{{ item.added ? 'check' : 'close-circle' }}</v-icon>
            {{ item.added ? datetime(item.updated_at, 'datetime') : 'ارسال نشده' }}
          </v-chip>
        </template>
      </vue-table>
    </v-card-text>

    <custom-popup v-model="showTransactions" :cons="{title: 'تراکنش‌های پیامکی'}" hide-confirm reloadable>
      <div class="pa-4">
        <vue-table :data="userTransactions" :headers="userHeaders" :loading="loading" @change="onChangeTransaction">
          <template v-slot:index="{item}">
            {{ (item.index + 1) + ((userTransactions.current_page - 1) * userTransactions.per_page) }}
          </template>

          <template v-slot:created_at="{item}">
            {{ datetime(item.created_at, 'datetime') }}
          </template>

          <template v-slot:type="{item}">
            {{ item.type | utType }}
          </template>
        </vue-table>
      </div>
    </custom-popup>

    <custom-popup v-model="dialog" :cons="cons" hide-confirm @close="selectedPackage = null">
      <v-card :loading="packageLoading" flat>
        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2" cols="12">
            <v-alert border="left" color="red" dark>
              برای ارسال پیامک تشکر از تماس، یک بسته پیامک خریداری نمایید.
            </v-alert>
          </v-col>

          <v-col v-for="(pack, i) in packages" :key="i" class="pa-2" cols="12" lg="4" md="6">
            <v-card :style="{borderColor: selectedPackage && selectedPackage.id === pack.id ? 'green' : ''}"
                    class="rounded-lg" outlined
                    @click="selectedPackage = pack">
              <v-card v-if="!$vuetify.breakpoint.mobile"
                      :color="selectedPackage && selectedPackage.id === pack.id ? 'success' : 'blue lighten-2'"
                      class="rounded-bottom-0 d-flex align-center justify-center" flat
                      height="200" width="100%">
                <h3 class="px-2">{{ persian(price(pack.price)) }}</h3> ﷼
              </v-card>

              <v-card-title v-text="pack.title"></v-card-title>
              <v-card-subtitle v-if="$vuetify.breakpoint.mobile">
                <span class="px-1">{{ persian(price(pack.price)) }}</span> ﷼
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <v-card-subtitle v-if="selectedPackage" class="text-center text-danger">
          به مبلغ انتخاب شده ۱۰ درصد مالیات افزوده میشود!
        </v-card-subtitle>

        <v-card-actions class="justify-center">
          <v-btn :disabled="!selectedPackage" :loading="packageLoading" class="btn-accept rounded-lg ma-0" depressed
                 width="200" @click="buyPanel">
            خرید
            <span v-if="!!selectedPackage" class="mr-2">{{ persian(price(computedPrice)) }} ﷼</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import {mapActions} from "vuex";
import SaveSteps from "@/view/pages/contacts/saveSteps.vue";

export default {
  name: "callLogsList",

  components: {SaveSteps},

  filters: {
    utType(type) {
      switch (type) {
        case 'payoff':
          return 'پرداختی'
        case 'buy':
          return 'خرید'
        default:
          return 'نامشخص'
      }
    }
  },

  data() {
    return {
      selectedRow: [],
      patternLoading: false,
      e6: 1,
      callLoading: false,
      headers: [
        {text: 'ردیف', value: 'index', sortable: false},
        {text: 'شناسه', value: 'id', sortable: false},
        {text: 'شماره', value: 'number', sortable: false},
        {text: 'نام', value: 'name', sortable: false},
        {text: 'زمان تماس', value: 'date', sortable: false},
        {text: 'مدت زمان مکالمه', value: 'duration', sortable: false},
        {text: 'نوع تماس', value: 'type', sortable: false},
        {text: 'وضعیت', value: 'added', sortable: false},
      ],
      selection: [],
      cons: {
        title: 'خرید بسته پیامک',
        buttons: [
          {type: 'submit', handler: this.buyPanel}
        ]
      },
      data: {},
      dialog: false,
      loading: false,
      tableProps: {
        page: 1,
        length: 10,
        dir: 'desc'
      },
      typeItems: [
        {value: 1, text: 'ورودی', icon: 'mdi-phone-incoming'},
        {value: 2, text: 'خروجی', icon: 'mdi-phone-outgoing'},
        {value: 3, text: 'از دست رفته', icon: 'mdi-phone-off'},
        {value: 5, text: 'بدون پاسخ', icon: 'mdi-phone-missed'},
        {value: 6, text: 'لیست سیاه', icon: 'mdi-phone-cancel'},
        {value: 7, text: 'پاسخ از دستگاه دیگر', icon: 'mdi-watch-export-variant'},
      ],
      packages: [],
      packageLoading: false,
      selectedPackage: null,
      userPackage: null,
      showTransactions: false,
      userTransactions: {},
      transactionsProps: {
        page: 1,
        length: 10,
        dir: 'desc'
      },
      userHeaders: [
        {value: 'index', text: 'ردیف', sortable: false},
        // {value: 'id', text: 'شناسه', sortable: false},
        {value: 'pre_stock', text: 'موجودی قبل ارسال', sortable: false},
        {value: 'count', text: 'تعداد پیام', sortable: false},
        {value: 'now_stock', text: 'باقی مانده بسته', sortable: false},
        {value: 'created_at', text: 'زمان', sortable: false},
        {value: 'type', text: 'نوع', sortable: false},
      ],
      noData: false
    }
  },

  mounted() {
    this.getList()
    this.refreshCallLogs()
    this.getUserPackage()
  },

  computed: {
    isApp() {
      return !!localStorage.getItem('isMobile')
    },
    hasPermission() {
      return !!localStorage.getItem('hasPermissions')
    },
    computedPrice() {
      return this.selectedPackage.price + (this.selectedPackage.price / 10)
    }
  },

  watch: {
    dialog(val) {
      this.getPanels()
    },
    showTransactions(val) {
      val && this.getTransactions()
    }
  },

  methods: {
    ...mapActions('ribbon', ['toggleWalletDialog']),
    getCallLogList() {
      this.callLoading = true

      // log into twa app to get permission from user android phone
      console.log('store_callLogs');
      setTimeout(() => {
        this.callLoading = false
        this.e6 = 2
      }, 5000)
    },
    getBatteryPermission() {
      this.callLoading = true

      console.log('battery_permission')
      setTimeout(() => {
        this.callLoading = false
        this.e6 = 3
      }, 5000)
    },
    setDefault() {
      this.patternLoading = true

      if (!this.selectedRow?.length) {
        setTimeout(() => {
          this.patternLoading = false
        }, 1000)
        return
      }

      this.requestApiPostPayamak('text/set/default', {
        type: !!Object.hasOwn(this.selectedRow[0], 'messages') ? 'campaign' : 'pattern',
        item_id: this.selectedRow[0].id
      })
        .then(({data}) => {
          this.dialog = false
          this.$toast.success('با موفقیت تنظیم شد.')
          this.saveSettings()
          this.$emit('reload')
        })
        .finally(() => this.patternLoading = false)
    },
    getList(params = this.tableProps) {
      this.loading = true

      this.requestApiGetPayamak('callLogs', params)
        .then(({data}) => {
          !this.noData && !this.data.data && (this.noData = !data?.data?.length)

          this.$nextTick(() => {
            this.data = data
          })
        })
        .catch(({response}) => console.log('failed to get call logs: ', response))
        .finally(() => this.loading = false)
    },
    getUserPackage() {
      this.loading = true

      this.requestApiGetPayamak('packages/user')
        .then(({data}) => {
          this.userPackage = data.data
        })
        .finally(() => this.loading = false)
    },
    // call and set callLogs list on page load
    refreshCallLogs() {
      // if (!this.hasPermission) return this.$toast.error('لطفا ابتدا دسترسی لیست تماس را برای ذخیره، فعال نمایید.', {timeout: 5000})

      // this.loading = true
      if (this.isApp && this.hasPermission)
        console.log('store_callLogs');
      // this.$toast.info('درخواست ذخیره لیست تماس با موفقیت ارسال شد.')

      // setTimeout(() => {
      //   this.loading = false
      //   this.$emit('reload')
      // }, 2000)
    },
    submitCallLogs() {
      if (!this.userPackage) {
        this.dialog = true;
        return
      }

      this.loading = true

      this.requestApiPostPayamak('convertCallLogs', {
        callLogs: this.selection.map(item => ({
          phone: item.number,
          id: item.id,
          name: item.name
        }))
      })
        .then(({data}) => {
          this.selection = []
          this.$toast.success('با موفقیت ذخیره شد.')
          this.getList()
        })
        .catch(({response}) => {
          console.log('failed to store call logs: ', response)
          this.$toast.error(response?.data?.message || 'خطا در ذخیره تماس‌ها!')
        })
        .finally(() => this.loading = false)
    },
    async deleteSelection() {
      if (await this.$modal.yesNo('حذف شماره‌های انتخاب شده از دفترچه تلفن ؟')) {
        this.loading = true

        this.requestApiDeletePayamak('callLogs/delete', {
          ids: this.selection.map(item => item.id)
        })
          .then(() => {
            this.selection = []
            this.getList()
          })
          .finally(() => this.loading = false)
      }
    },
    typeText(e) {
      switch (e) {
        case 1:
          return {
            icon: 'phone-incoming', text: 'ورودی', color: 'success'
          }
        case 2:
          return {
            icon: 'phone-outgoing', text: 'خروجی', color: 'warning'
          }
        case 3:
          return {
            icon: 'phone-off', text: 'ازدست رفته', color: 'red'
          }
        case 5:
          return {
            icon: 'phone-missed', text: 'بدون پاسخ', color: 'red'
          }
        case 6:
          return {
            icon: 'phone-cancel', text: 'لیست سیاه', color: 'grey'
          }
        case 7:
          return {
            icon: 'watch-export-variant', text: 'پاسخ از دستگاه دیگر', color: 'success'
          }
        default:
          return {
            icon: 'phone-alert', text: 'نامشخص', color: 'grey'
          }
      }
    },
    durationSlot(e) {
      let sec = e % 60
      let min = Math.floor(e / 60)

      return {
        min: {
          time: min, text: 'دقیقه'
        },
        sec: {
          time: sec, text: 'ثانیه'
        }
      }
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e
      }

      this.$nextTick(() => {
        this.getList(props)
      })
    },
    getPanels() {
      this.packageLoading = true

      this.requestApiGetPayamak('packages')
        .then(({data}) => {
          this.packages = data.data
        })
        .catch(({response}) => console.log('failed to get packages list: ', response))
        .finally(() => this.packageLoading = false)
    },
    buyPanel() {
      this.packageLoading = true

      this.requestApiGetPayamak(`packages/buy/${this.selectedPackage.id}`)
        .then(({data}) => {
          this.$toast.success('با موفقیت خریداری شد.')
          this.selectedPackage = null
          this.dialog = false
          this.getUserPackage()
        })
        .catch(({response}) => {
          console.log('failed to buy package: ', response)
          if (response.status === 400)
            this.$modal.wallet(null, null, null, {
              onClick: () => this.toggleWalletDialog(true)
            })
          else
            this.$toast.error(response?.data?.message || 'خطا در خرید بسته!')
        })
        .finally(() => this.packageLoading = false)
    },
    getTransactions(params = this.transactionsProps) {
      this.loading = true

      this.requestApiGetPayamak(`packages/user/logs/${this.userPackage.id}`, params)
        .then(({data}) => this.userTransactions = data.data)
        .finally(() => this.loading = false)
    },
    onChangeTransaction(e) {
      let props = {
        ...this.transactionsProps,
        ...e
      }

      this.getTransactions(props)
    },
    saveSettings() {
      this.loading = true

      this.requestApiPostPayamak('settings/store', {
        send_payamak: {
          auto_send: true,
          list_only: false,
          after_notify: false
        },
        number_type: {
          contacts: false,
          not_contacts: false,
          stored_number: false,
          unstored_number: true
        },
        call_type: {
          blacklist: false,
          lost_calls: true,
          input_calls: true,
          other_device: true,
          output_calls: false,
          unanswered_calls: true
        },
        advanced: {
          from_bale: false,
          add_phoneData: false
        }
      })
        .then(({data}) => {
          console.log('sync_settings')
          this.$modal.info('تنظیمات شما با موفقیت ثبت شد')
        })
        .catch(({response}) => {
          this.$toast.error('خطا در ذخیره تنظیمات')
        })
        .finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>

</style>